import { isRealtorsForum } from './is_realtors_forum';

const BANNER_POSITIONS = [10, 30, 50]

export const showDemandBanner = (index: number, pathname?: string) => {
  return BANNER_POSITIONS.includes(index + 1) && isRealtorsForum(pathname);
}
